import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { useThemeStore } from '../../stores/themeStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { verifyAuth } = useAuthStore();
  const { theme } = useThemeStore();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      await verifyAuth();
      setIsVerifying(false);
    };
    
    initAuth();
  }, [verifyAuth]);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'light') {
      root.classList.add('light');
    } else {
      root.classList.remove('light');
    }
  }, [theme]);

  if (isVerifying) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-primary)' }}>
        <div className="flex flex-col items-center">
          <div className="w-10 h-10 border-2 border-emerald-500/30 border-t-teal-500 rounded-full animate-spin mb-4"></div>
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>验证身份中...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
